import React, { lazy, Suspense, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Flex, Spin } from 'antd';
import ProtectedRoute from "./components/ProtectedRoute";
import { NotificationProvider } from './context/NotificationContext';

// Lazy Load
const Login = lazy(() => import("./components/Auth/Login"))
const Page404 = lazy(() => import("./pages/Page404"))
const DefaultLayout = lazy(() => import("./layout/DefaultLayout"))
const Tasks = lazy(() => import("./components/Task/TaskTab"))

const App = () => {
  const [loggedin,setLoggedIn] = useState(false)
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if(token) setLoggedIn(true)
  }, []);
  return (
    <NotificationProvider>
      <Suspense
        fallback={
          <Flex align="center" gap="middle">
            <Spin />
          </Flex>
        }
      >
        <Router>
          <Routes>
            <Route path="/" element={loggedin? <DefaultLayout/>  :<Login />} />
            <Route path="/login" name="Login Page" element={<Login />} />
            <Route path="/404" name="Page 404" element={<Page404 />} />
            <Route path="*" name="Home" element=
              {
                <ProtectedRoute>
                  <DefaultLayout />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </Suspense>
    </NotificationProvider>
  );
};

export default App;
